export default __webpack_public_path__ + "static/media/img_about7@2x.min.4289cc43.jpg";